module.exports = __webpack_public_path__ + "static/img/match-intro-img.7e85cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/match-intro-img.png
// module id = uCSC
// module chunks = 2 3